/**
 * Reload the page when the cart drawer closes after the cart changed.
 * Keeps nested add-on state fresh without relying on stale drawer AJAX state.
 */
(function () {
  function markDirtyIfOpen() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active')) {
      drawer._reloadCartChangedWhileOpen = true;
    }
  }

  function patchCartDrawer() {
    const CartDrawer = customElements.get('cart-drawer');
    if (!CartDrawer || CartDrawer.prototype.__agrotropicReloadPatched) return;

    const proto = CartDrawer.prototype;
    const originalOpen = proto.open;
    const originalClose = proto.close;
    const originalRenderContents = proto.renderContents;

    proto.open = function (triggeredBy) {
      // Opening from the header icon starts a fresh session.
      // Opening via renderContents after an add must keep the dirty flag.
      if (!this._reloadOpeningFromCartUpdate) {
        this._reloadCartChangedWhileOpen = false;
      }
      this._reloadOpeningFromCartUpdate = false;
      return originalOpen.call(this, triggeredBy);
    };

    proto.renderContents = function (parsedState) {
      this._reloadCartChangedWhileOpen = true;
      this._reloadOpeningFromCartUpdate = true;
      return originalRenderContents.call(this, parsedState);
    };

    proto.close = function () {
      const shouldReload = Boolean(this._reloadCartChangedWhileOpen);
      this._reloadCartChangedWhileOpen = false;
      originalClose.call(this);

      if (shouldReload) {
        window.location.reload();
      }
    };

    proto.__agrotropicReloadPatched = true;
  }

  customElements.whenDefined('cart-drawer').then(patchCartDrawer);

  function subscribeToCartUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, markDirtyIfOpen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', subscribeToCartUpdates);
  } else {
    subscribeToCartUpdates();
  }
})();
